import { TownList } from '@/services/user'

const userInfoStr = localStorage.getItem('userInfoApp')
const townId = localStorage.getItem('townId') || ''
const publishType = localStorage.getItem('publishType') || ''
let userInfo
try {
  userInfo = JSON.parse(userInfoStr)
} catch (error) {
  userInfo = null
}

const state = {
  userInfo,
  townList: [],
  townId,
  publishType
}

const mutations = {
  updateUserInfo(state, payload) {
    state.userInfo = payload
  },
  updateTownList(state, { payload }) {
    state.townList = payload
  },
  updateTownId(state, payload) {
    const townId = payload || ''
    state.townId = townId
    localStorage.setItem('townId', townId)
    if (townId) {
      localStorage.setItem('lastTownId', townId)
    }
  },
  updatePublishType(state, payload) {
    state.publishType = payload
    localStorage.setItem('publishType', payload)
  }
}

const actions = {
  async fetchTownList({ commit }, payload) {
    const response = await TownList(payload)
    if (response && response.code === '0') {
      const townList = response.data || []
      commit({ type: 'updateTownList', payload: townList })
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js